import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { UtilModule } from '@sd-portal/shared/util';

import { reducers, SHARED_AUDIT_FEATURE } from './+state';
import { SharedAuditEffects } from './+state/shared-audit.effects';
import { SharedAuditFacade } from './+state/shared-audit.facade';

import { AuditComponent } from './audit/audit.component';
import { AuditDetailComponent } from './audit-detail/audit-detail.component';
import { AuditDetailListComponent } from './audit-detail-list/audit-detail-list.component';
import { AuditDetailV2Component } from './audit-detail-v2/audit-detail-v2.component';
import { AuditDetailListV2Component } from './audit-detail-list-v2/audit-detail-list-v2.component';

import { AircraftEventFacade } from './+state/aircraft-event/aircraft-event.facade';
import { AircraftEventAuditListComponent } from './aircraft-event/aircraft-event-audit-list/aircraft-event-audit-list.component';
import { AircraftEventBusinessPersonAuditListComponent } from './aircraft-event/aircraft-event-business-person-audit-list/aircraft-event-business-person-audit-list.component';

import { AircraftEventAuditService } from './aircraft-event-audit.service';
import { AircraftEventComponent } from './aircraft-event/aircraft-event.component';
import { AircraftEventEffects } from './+state/aircraft-event/aircraft-event.effects';
import { AircraftProfileEffects } from './+state/aircraft-profile/aircraft-profile.effects';
import { AircraftProfileFacade } from './+state/aircraft-profile/aircraft-profile.facade';

import { AddressAuditListComponent } from './aircraft-profile/address-audit-list/address-audit-list.component';
import { AircraftProfileAuditListComponent } from './aircraft-profile/aircraft-profile-audit-list/aircraft-profile-audit-list.component';
import { AircraftProfileAuditService } from './aircraft-profile-audit.service';
import { AircraftProfileComponent } from './aircraft-profile/aircraft-profile.component';
import { AircraftRelationAuditListComponent } from './aircraft-profile/aircraft-relation-audit-list/aircraft-relation-audit-list.component';
import { AirportProfileComponent } from './airport-profile/airport-profile.component';
import { ColorSettingAuditListComponent } from './aircraft-profile/color-setting-audit-list/color-setting-audit-list.component';
import { EmailAddressAuditListComponent } from './aircraft-profile/email-address-audit-list/email-address-audit-list.component';
import { EngineAuditListComponent } from './aircraft-profile/engine-audit-list/engine-audit-list.component';
import { EngineRelationAuditListComponent } from './aircraft-profile/engine-relation-audit-list/engine-relation-audit-list.component';
import { ComponentAuditListComponent } from './aircraft-profile/component-audit-list/component-audit-list.component';
import { PerformanceAuditListComponent } from './aircraft-profile/performance-audit-list/performance-audit-list.component';
import { PhoneNumberAuditListComponent } from './aircraft-profile/phone-number-audit-list/phone-number-audit-list.component';
import { PostFlightVisibilityAuditListComponent } from './aircraft-profile/postflight-visibility-audit-list/postflight-visibility-audit-list.component';
import { AircraftBillingRateAuditListComponent } from './aircraft-profile/aircraft-billing-rate-audit-list/aircraft-billing-rate-audit-list.component';

import { PersonProfileAuditService } from './person-profile-audit.service';
import { PersonProfileFacade } from './+state/person-profile/person-profile.facade';
import { PersonProfileEffects } from './+state/person-profile/person-profile.effects';
import { PersonProfileAddressAuditListComponent } from './person-profile/person-profile-address-audit-list/person-profile-address-audit-list.component';
import { PersonProfileAttributeAuditListComponent } from './person-profile/person-profile-attribute-audit-list/person-profile-attribute-audit-list.component';
import { PersonProfileAuditListComponent } from './person-profile/person-profile-audit-list/person-profile-audit-list.component';
import { PersonProfileBusinessPersonAuditListComponent } from './person-profile/person-profile-business-person-audit-list/person-profile-business-person-audit-list.component';
import { PersonProfileComponent } from './person-profile/person-profile.component';
import { PersonProfileContactInfoAuditListComponent } from './person-profile/person-profile-contact-info-audit-list/person-profile-contact-info-audit-list.component';
import { PersonProfileCrewMemberTypeRatingAuditListComponent } from './person-profile/person-profile-crew-member-type-rating-audit-list/person-profile-crew-member-type-rating-audit-list.component';
import { PersonProfileEmailAddressAuditListComponent } from './person-profile/person-profile-email-address-audit-list/person-profile-email-address-audit-list.component';
import { PersonProfileEmergencyContactAuditListComponent } from './person-profile/person-profile-emergency-contact-audit-list/person-profile-emergency-contact-audit-list.component';
import { PersonProfileEmergencyContactPhoneNumberAuditListComponent } from './person-profile/person-profile-emergency-contact-phone-number-audit-list/person-profile-emergency-contact-phone-number-audit-list.component';
import { PersonProfileExecutiveAssociateAuditListComponent } from './person-profile/person-profile-executive-associate-audit-list/person-profile-executive-associate-audit-list.component';
import { PersonProfileExecutiveAssociateEmailAuditListComponent } from './person-profile/person-profile-executive-associate-email-audit-list/person-profile-executive-associate-email-audit-list.component';
import { PersonProfileExecutiveAssociatePhoneNumberAuditListComponent } from './person-profile/person-profile-executive-associate-phone-number-audit-list/person-profile-executive-associate-phone-number-audit-list.component';
import { PersonProfilePhoneNumberAuditListComponent } from './person-profile/person-profile-phone-number-audit-list/person-profile-phone-number-audit-list.component';
import { PersonProfilePreferenceAuditListComponent } from './person-profile/person-profile-preference-audit-list/person-profile-preference-audit-list.component';
import { PersonProfilePersonStaffGroupAuditListComponent } from './person-profile/person-profile-person-staff-groups-audit-list/person-profile-person-staff-groups-audit-list.component';
import { PersonProfileStaffDetailAuditListComponent } from './person-profile/person-profile-staff-detail-audit-list/person-profile-staff-detail-audit-list.component';
import { PersonProfileTaxInfoAuditListComponent } from './person-profile/person-profile-tax-info-audit-list/person-profile-tax-info-audit-list.component';

import { TrainingRequirementAuditService } from './training-requirement-audit.service';
import { TrainingRequirementFacade } from './+state/training-requirement/training-requirement.facade';
import { TrainingRequirementEffects } from './+state/training-requirement/training-requirement.effects';
import { TrainingRequirementProfileComponent } from './training-requirement-profile/training-requirement-profile.component';

import { StaffMemberAuditListComponent } from './training-requirement-profile/staff-member-list/staff-member-audit-list/staff-member-audit-list.component';
import { TrainingEventAuditListComponent } from './training-requirement-profile/training-event-audit-list/training-event-audit-list.component';
import { StaffMemberListComponent } from './training-requirement-profile/staff-member-list/staff-member-list.component';
import { WarningRuleAuditListComponent } from './training-requirement-profile/training-event-audit-list/warning-rule-audit-list/warning-rule-audit-list.component';

import { StaffEventAuditListComponent } from './staff-event/staff-event-audit-list/staff-event-audit-list.component';
import { StaffEventAuditService } from './staff-event-audit.service';
import { StaffEventBusinessPersonAuditListComponent } from './staff-event/staff-event-business-person-audit-list/staff-event-business-person-audit-list.component';
import { StaffEventComponent } from './staff-event/staff-event.component';
import { StaffEventEffects } from './+state/staff-event/staff-event.effects';
import { StaffEventFacade } from './+state/staff-event/staff-event.facade';

import { CompanyProfileComponent } from './company-profile/company-profile.component';
import { CompanyProfileFacade } from './+state/company-profile/company-profile.facade';
import { CompanyProfileAuditService } from './company-profile-audit.service';
import { CompanyProfileEffects } from './+state/company-profile/company-profile.effects';
import { CompanyProfileAuditListComponent } from './company-profile/company-profile-audit-list/company-profile-audit-list.component';
import { AircraftTypeRatingAuditListComponent } from './company-profile/aircraft-type-rating-audit-list/aircraft-type-rating-audit-list.component';
import { CompanyAddressAuditListComponent } from './company-profile/company-address-audit-list/company-address-audit-list.component';
import { CustomerDutyAuditListComponent } from './company-profile/customer-duty-audit-list/customer-duty-audit-list.component';
import { DelayTypeAuditListComponent } from './company-profile/delay-type-audit-list/delay-type-audit-list.component';
import { DepartmentAuditListComponent } from './company-profile/department-audit-list/department-audit-list.component';
import { DutyTimeBufferAuditListComponent } from './company-profile/duty-time-buffer-audit-list/duty-time-buffer-audit-list.component';
import { ExpenseTypeAuditListComponent } from './company-profile/expense-type-audit-list/expense-type-audit-list.component';
import { CrewMemberTypeAuditListComponent } from './company-profile/crew-member-type-audit-list/crew-member-type-audit-list.component';
import { PaymentTypeAuditListComponent } from './company-profile/payment-type-audit-list/payment-type-audit-list.component';
import { BusinessCategoryAuditListComponent } from './company-profile/business-category-audit-list/business-category-audit-list.component';
import { JobGradeAuditListComponent } from './company-profile/job-grade-audit-list/job-grade-audit-list.component';
import { StaffEventTypeAuditListComponent } from './company-profile/staff-event-type-audit-list/staff-event-type-audit-list.component';
import { DutyTimeAllowanceAuditListComponent } from './company-profile/duty-time-allowance-audit-list/duty-time-allowance-audit-list.component';

import { TripEffects } from './+state/trip/trip.effects';
import { TripFacade } from './+state/trip/trip.facade';
import { TripAuditService } from './trip-audit.service';
import { DeletedTripsComponent } from './trip/deleted-trips/deleted-trips.component';
import { ScheduledTripComponent } from './trip/scheduled-trip/scheduled-trip.component';
import { TripAuditComponent } from './trip/trip.component';
import { TripManagerComponent } from './trip-manager/trip-manager.component';
import { TripManagerFacade } from './+state/trip-manager/trip-manager.facade';
import { TripManagerAuditService } from './trip-manager-audit.service';
import { TripManagerEffects } from './+state/trip-manager/trip-manager.effects';
import { TripManagerTripComponent } from './trip-manager/trip-manager-trip/trip-manager-trip.component';
import { PostedFlightFacade } from './+state/posted-flight/posted-flight.facade';
import { PostedFlightEffects } from './+state/posted-flight/posted-flight.effects';
import { PostedFlightAuditService } from './posted-flight-audit.service';
import { PostedFlightComponent } from './posted-flight/posted-flight.component';
import { SimulatedFlightFacade } from './+state/simulated-flight/simulated-flight.facade';
import { SimulatedFlightEffects } from './+state/simulated-flight/simulated-flight.effects';
import { SimulatedFlightAuditService } from './simulated-flight-audit.service';
import { SimulatedFlightComponent } from './simulated-flight/simulated-flight.component';
import { ExpenseFacade } from './+state/expense/expense.facade';
import { ExpenseEffects } from './+state/expense/expense.effects';
import { ExpenseAuditService } from './expense-audit.service';
import { ExpenseComponent } from './expense/expense.component';
import { DeletedExpenseAuditListComponent } from './expense/expense-audit-list/deleted-expense-audit-list.component';
import { StaffGroupAuditListComponent } from './company-profile/staff-group-audit-list/staff-group-audit-list.component';
import { PersonProfilePassengerAuditListComponent } from './person-profile/person-profile-passenger-audit-list/person-profile-passenger-audit-list.component';
import { TrainingGroupAuditListComponent } from './training-requirement-profile/training-group-audit-list/training-group-audit-list.component';
import { TrainingGroupTrainingRequirementAuditListComponent } from './training-requirement-profile/training-group-audit-list/training-group-training-requirement-audit-list/training-group-training-requirement-audit-list.component';
import { FleetOverviewAuditComponent } from './fleet-overview/fleet-overview-audit.component';
import { FleetAuditService } from './fleet-audit.service';
import { UserManagementAuditComponent } from './user-management/user-management-audit.component';
import { UsersAuditService } from './users-audit.service';
import { RoleManagementAuditComponent } from './role-management/role-management-audit.component';
import { RolesAuditService } from './roles-audit.service';

@NgModule({
  imports: [
    CommonModule,
    InfiniteScrollModule,
    UtilModule,
    StoreModule.forFeature(SHARED_AUDIT_FEATURE, reducers),
    EffectsModule.forFeature([
      SharedAuditEffects,
      AircraftEventEffects,
      AircraftProfileEffects,
      CompanyProfileEffects,
      PersonProfileEffects,
      TrainingRequirementEffects,
      StaffEventEffects,
      TripEffects,
      TripManagerEffects,
      PostedFlightEffects,
      SimulatedFlightEffects,
      ExpenseEffects
    ])
  ],
  declarations: [
    AuditComponent,
    AuditDetailComponent,
    AuditDetailListComponent,
    AuditDetailV2Component,
    AuditDetailListV2Component,
    AircraftEventComponent,
    AircraftEventAuditListComponent,
    AircraftEventBusinessPersonAuditListComponent,
    AircraftProfileComponent,
    AircraftProfileAuditListComponent,
    AirportProfileComponent,
    CompanyProfileComponent,

    PersonProfileAddressAuditListComponent,
    PersonProfileAttributeAuditListComponent,
    PersonProfileAuditListComponent,
    PersonProfileBusinessPersonAuditListComponent,
    PersonProfileComponent,
    PersonProfileContactInfoAuditListComponent,
    PersonProfilePassengerAuditListComponent,
    PersonProfileCrewMemberTypeRatingAuditListComponent,
    PersonProfileEmailAddressAuditListComponent,
    PersonProfileEmergencyContactAuditListComponent,
    PersonProfileEmergencyContactPhoneNumberAuditListComponent,
    PersonProfilePhoneNumberAuditListComponent,
    PersonProfileExecutiveAssociateAuditListComponent,
    PersonProfileExecutiveAssociatePhoneNumberAuditListComponent,
    PersonProfileExecutiveAssociateEmailAuditListComponent,
    PersonProfilePreferenceAuditListComponent,
    PersonProfileStaffDetailAuditListComponent,
    PersonProfileTaxInfoAuditListComponent,

    TrainingRequirementProfileComponent,
    ColorSettingAuditListComponent,
    PerformanceAuditListComponent,
    EngineAuditListComponent,
    EngineRelationAuditListComponent,
    ComponentAuditListComponent,
    PostFlightVisibilityAuditListComponent,
    AircraftBillingRateAuditListComponent,
    AircraftRelationAuditListComponent,
    PhoneNumberAuditListComponent,
    EmailAddressAuditListComponent,
    AddressAuditListComponent,
    TrainingEventAuditListComponent,
    StaffMemberListComponent,
    StaffMemberAuditListComponent,
    WarningRuleAuditListComponent,
    AircraftEventComponent,
    StaffEventComponent,
    StaffEventAuditListComponent,
    StaffEventBusinessPersonAuditListComponent,
    CompanyProfileAuditListComponent,
    AircraftTypeRatingAuditListComponent,
    CompanyAddressAuditListComponent,
    CustomerDutyAuditListComponent,
    DelayTypeAuditListComponent,
    DepartmentAuditListComponent,
    DutyTimeBufferAuditListComponent,
    ExpenseTypeAuditListComponent,
    CrewMemberTypeAuditListComponent,
    PaymentTypeAuditListComponent,
    BusinessCategoryAuditListComponent,
    JobGradeAuditListComponent,
    StaffEventTypeAuditListComponent,
    DeletedTripsComponent,
    ScheduledTripComponent,
    TripAuditComponent,
    TripManagerComponent,
    TripManagerTripComponent,
    PostedFlightComponent,
    SimulatedFlightComponent,
    ExpenseComponent,
    DeletedExpenseAuditListComponent,
    StaffGroupAuditListComponent,
    PersonProfilePersonStaffGroupAuditListComponent,
    DutyTimeAllowanceAuditListComponent,
    TrainingGroupAuditListComponent,
    TrainingGroupTrainingRequirementAuditListComponent,
    FleetOverviewAuditComponent,
    UserManagementAuditComponent,
    RoleManagementAuditComponent
  ],
  exports: [AuditComponent],
  providers: [
    SharedAuditFacade,
    AircraftEventAuditService,
    AircraftEventFacade,
    AircraftProfileFacade,
    AircraftProfileAuditService,
    CompanyProfileFacade,
    CompanyProfileAuditService,
    PersonProfileAuditService,
    PersonProfileFacade,
    StaffEventFacade,
    StaffEventAuditService,
    TrainingRequirementFacade,
    TrainingRequirementAuditService,
    TripFacade,
    TripAuditService,
    TripManagerFacade,
    TripManagerAuditService,
    PostedFlightFacade,
    PostedFlightAuditService,
    SimulatedFlightFacade,
    SimulatedFlightAuditService,
    ExpenseFacade,
    ExpenseAuditService,
    FleetAuditService,
    UsersAuditService,
    RolesAuditService
  ]
})
export class SharedAuditModule {}
